export enum InputValidationTypes {
  Required,
  Domain,
  Email,
  MinLength,
  Protocal,
  MaxLength,
}
